/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-alert */
/* eslint-disable arrow-body-style */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useMemo } from "react";
import Page from "../../../components/Page";
import adminServices from '../../../services/adminServices';

export default function ScoringTable({ scoreDetails = {}, handleSubmitScore }) {
  const [name, setName] = useState("");
  const [questionPerAttempt, setQuestionPerAttempt] = useState(0);
  const [type, setType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [scaledMap, setScaledMap] = useState(scoreDetails || {});
  const [assessmentTypeList, setAssessmentTypeList] = useState([]);
  const [errors, setErrors] = useState({ name: "", questionPerAttempt: "", type: "" });
  const [scaleErrors, setScaleErrors] = useState({});
  console.log(scoreDetails, "scoreDetails");


  React.useEffect(() => {
    if (scoreDetails && scoreDetails.id) {
      setName(scoreDetails.template_name);
      setQuestionPerAttempt(scoreDetails.qn_count);
      setType(scoreDetails.assessment_type_code);
      setScaledMap(scoreDetails.scale_score || {});
    }
  }, [scoreDetails]);

  React.useEffect(() => {
    getAssessmentTypeList();
  }, [])

  const getAssessmentTypeList = async () => {
    try {
      const result = await adminServices.getAssessmentTypeDropdown();
      if (result && result.ok) {
        const list = result.data?.data || result.data || [];
        setAssessmentTypeList(list);
      }
    } catch (error) {
      console.error('Assessment Type dropdown API not ready:', error);
      setAssessmentTypeList([]);
    }
  };

  const validateScaledMap = () => {
    const errors = {};
    let valid = true;

    rawScores.forEach((raw) => {
      const val = (scaledMap[raw] || "").toString().trim();

      if (!val) {
        errors[raw] = "Required";
        valid = false;
        return;
      }

      if (!/^(\d+|\d+-\d+)$/.test(val)) {
        errors[raw] = "Invalid format (e.g. 210 or 210-280)";
        valid = false;
        return;
      }

      if (val.includes("-")) {
        const [min, max] = val.split("-").map(Number);

        if (max < min) {
          errors[raw] = "Maximum score must be greater than or equal to minimum score";
          valid = false;
        }
      }
    });

    setScaleErrors(errors);
    return valid;
  };
  // const validateScaledMap = () => {
  //   const errors = {};
  //   let valid = true;

  //   rawScores.forEach((raw) => {
  //     const val = (scaledMap[raw] || "").toString().trim();

  //     if (!val) {
  //       errors[raw] = "Required";
  //       valid = false;
  //     } else if (!/^(\d+|\d+-\d+)$/.test(val)) {
  //       errors[raw] = "Invalid format (e.g. 210 or 210-280)";
  //       valid = false;
  //     }
  //   });

  //   setScaleErrors(errors);
  //   return valid;
  // };
  const rawScores = useMemo(() => {
    return Array.from({ length: Number(questionPerAttempt) + 1 }, (_, i) => i);
  }, [questionPerAttempt]);

  const isValidRange = (val) => /^(\d+|\d+-\d+)$/.test(val.trim());

  const handleChange = (raw, value) => {
    setScaledMap((prev) => ({ ...prev, [raw]: value }));
  };

  const validate = () => {
    const newErrors = {
      name: "",
      questionPerAttempt: "",
      type: "",
    };

    let isValid = true;

    if (!name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }

    if (!questionPerAttempt || Number(questionPerAttempt) <= 0) {
      newErrors.questionPerAttempt = "Questions Per Attempt is required";
      isValid = false;
    }

    if (!type) {
      newErrors.type = "Type is required";
      isValid = false;
    }

    setErrors(newErrors);

    if (!validateScaledMap()) {
      isValid = false;
    }

    return isValid;
  };

  const handleSave = async () => {
    if (!validate()) return;
    setIsSubmitting(true);
    await handleSubmitScore({ name, questionPerAttempt, mapping: scaledMap, type, id: scoreDetails?.id ? scoreDetails?.id : '' });
    setIsSubmitting(false);
  };

  return (
    <Page title="">
      <div className="h-full flex flex-col bg-gray-100">
        <div className="bg-white shadow-sm border-b px-8 py-5 flex items-start gap-10">
          <div className="flex flex-col">
            <label className="text-xs text-gray-500 font-medium mb-1">
              Name
              <span className="text-red-500"> *</span>
            </label>

            <input value={name} onChange={(e) => {
              setName(e.target.value);
              setErrors((prev) => ({ ...prev, name: "" }));
            }}
              placeholder="Enter Name"
              className={`w-72 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 ${errors.name ? "border-red-500" : ""}`}
            />

            <p className="text-red-500 text-xs mt-1 min-h-[16px]">
              {errors.name || "\u00A0"}
            </p>
          </div>

          <div className="flex flex-col">
            <label className="text-xs text-gray-500 font-medium mb-1">
              Questions Per Attempt
              <span className="text-red-500"> *</span>
            </label>

            <input
              type="text"
              inputMode="numeric"
              value={questionPerAttempt}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setQuestionPerAttempt(value);
                  setErrors((prev) => ({ ...prev, questionPerAttempt: "" }));
                }
              }}
              onKeyDown={(e) => {
                const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                if (allowed.includes(e.key)) return;
                if (/^[0-9]$/.test(e.key)) return;
                e.preventDefault();
              }}
              onPaste={(e) => {
                const paste = e.clipboardData.getData("text");
                if (!/^\d+$/.test(paste)) {
                  e.preventDefault();
                }
              }}
              className={`w-40 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 ${errors.questionPerAttempt ? "border-red-500" : ""}`}
            />

            <p className="text-red-500 text-xs mt-1 min-h-[16px]">
              {errors.questionPerAttempt || "\u00A0"}
            </p>
          </div>

          <div className="flex flex-col">
            <label htmlFor="assessment-category" className="text-xs text-gray-500 font-medium mb-1">
              Type
              <span className="text-red-500"> *</span>
            </label>

            <div className="relative">
              <select
                id="assessment-category"
                name="category"
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                  setErrors((prev) => ({ ...prev, type: "" }));
                }}
                className={`w-full border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 bg-white appearance-none cursor-pointer pr-10 ${errors.type ? "border-red-500" : ""}`}
              >
                <option value="">Select Type</option>
                {assessmentTypeList &&
                  assessmentTypeList?.map((item) => (
                    <option key={item.id} value={item.code}>
                      {item.code}
                    </option>
                  ))}
              </select>

              <svg className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            <p className="text-red-500 text-xs mt-1 min-h-[16px]">
              {errors.type || "\u00A0"}
            </p>
          </div>

          <button onClick={handleSave} disabled={isSubmitting} className={`ml-auto px-6 py-2.5 rounded-md text-sm font-semibold text-white shadow ${isSubmitting ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700 transition"}`} >
            {isSubmitting ? "Saving..." : scoreDetails?.id ? "Update Scores" : "Save Scores"}
          </button>
        </div>
        <div className="flex-1 p-8 overflow-hidden">
          <div className="bg-white rounded-xl shadow border h-full flex flex-col">
            <div className="grid grid-cols-2 bg-gray-50 text-gray-700 font-semibold text-sm px-8 py-4 border-b sticky top-0 z-10">
              <div>RAW SCORE</div>
              <div>SCALED SCORE (Range Allowed)</div>
            </div>

            <div className="overflow-y-auto">
              {rawScores.map((raw) => (
                <div
                  key={raw}
                  className="grid grid-cols-2 items-center px-8 py-4 border-b last:border-b-0 hover:bg-gray-50"
                >
                  <div className="text-gray-800 font-medium">{raw}</div>
                  <input
                    type="text"
                    value={scaledMap[raw] || ""}
                    inputMode="numeric"
                    placeholder="e.g. 200-250"
                    className="w-64 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                    onKeyDown={(e) => {
                      const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                      if (allowed.includes(e.key)) return;
                      if (/^[0-9]$/.test(e.key)) return;
                      if (e.key === "-" && !e.currentTarget.value.includes("-") && e.currentTarget.value.length > 0) return;
                      e.preventDefault();
                    }}

                    onPaste={(e) => {
                      const paste = e.clipboardData.getData("text");
                      if (!/^\d+-\d+$/.test(paste)) {
                        e.preventDefault();
                      }
                    }}

                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*-?\d*$/.test(value)) {
                        handleChange(raw, value);
                        setScaleErrors((prev) => ({ ...prev, [raw]: "" }));
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;

                      if (!/^\d+-\d+$/.test(value)) {
                        setScaleErrors((prev) => ({
                          ...prev,
                          [raw]: "Format must be like 200-250",
                        }));
                        return;
                      }

                      const [min, max] = value.split("-").map(Number);

                      if (max < min) {
                        setScaleErrors((prev) => ({
                          ...prev,
                          [raw]: "Maximum score cannot be less than minimum score",
                        }));
                        return;
                      }

                      setScaleErrors((prev) => ({
                        ...prev,
                        [raw]: "",
                      }));
                    }}
                  // onBlur={(e) => {
                  //   const value = e.target.value;
                  //   if (!/^\d+-\d+$/.test(value)) {
                  //     setScaleErrors((prev) => ({
                  //       ...prev,
                  //       [raw]: "Format must be like 200-250",
                  //     }));
                  //   }
                  // }}
                  />
                  {scaleErrors[raw] && (
                    <p className="text-red-500 text-xs mt-1">{scaleErrors[raw]}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}